"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLendingVaultsUserData = exports.initializeLendingVaultsUserData = exports.fetchLendingVaultsUserData = exports.getWhitelistState = exports.getWhitelistData = exports.initializeWhitelistData = exports.fetchWhitelist = exports.getLendingVaultData = exports.getLendingVaultsData = exports.initializeLendingVaultsData = exports.fetchLendingVaults = exports.getXimxData = exports.initializeXimxData = exports.getUserData = exports.initializeUserData = exports.fetchUserData = exports.getTvlData = exports.initializeTvlData = exports.getLendingPoolData = exports.getLendingPoolsData = exports.initializeLendingPoolsData = exports.fetchUniswapAPR = exports.fetchCurrentVolumeAndReserves = exports.fetchPastVolume = exports.fetchImpermaxChefRewardRates = exports.fetchLendingPoolsPast = exports.fetchLendingPools = exports.fetchBlockByTimestamp = exports.apolloFetcher = void 0;
const apollo_client_1 = __importDefault(require("apollo-client"));
const apollo_link_http_1 = require("apollo-link-http");
const apollo_cache_inmemory_1 = require("apollo-cache-inmemory");
const queries_1 = require("./queries");
const lendingPool_1 = __importDefault(require("./lendingPool"));
const subgraphs_1 = require("../config/subgraphs");
const types_1 = require("../config/types");
const amms_1 = require("../config/amms");
const offchainLendingVault_1 = __importDefault(require("./offchainLendingVault"));
const impermax_factories_1 = require("../config/contracts/impermax-factories");
const SECONDS_IN_YEAR = 60 * 60 * 24 * 365;
function apolloFetcher(subgraphUrl, query) {
    return __awaiter(this, void 0, void 0, function* () {
        const client = new apollo_client_1.default({
            link: new apollo_link_http_1.HttpLink({
                uri: subgraphUrl,
            }),
            cache: new apollo_cache_inmemory_1.InMemoryCache(),
        });
        const result = yield client.query({
            query: query,
            fetchPolicy: 'cache-first',
        });
        return queries_1.QueryBuilderFactory.transformData(result);
    });
}
exports.apolloFetcher = apolloFetcher;
function fetchBlockByTimestamp(timestamp) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            if (subgraphs_1.BLOCKS_SUBGRAPH_URL[this.network].length == 0)
                return null;
            const subgraph = subgraphs_1.BLOCKS_SUBGRAPH_URL[this.network];
            const query = queries_1.QueryBuilderFactory.getQuery(subgraph);
            const result = yield this.apolloFetcher(subgraph, query.blockQuery(timestamp));
            // TODO: This is wrong in case of different endpoints?
            console.log(result.data._meta.block.number);
            if (!result.data.blocks[0])
                return null;
            return result.data.blocks[0].number;
        }
        catch (e) {
            console.log("can't fetch blocks by timestamp");
            return null;
        }
    });
}
exports.fetchBlockByTimestamp = fetchBlockByTimestamp;
// Fetch Lending Pools
function fetchLendingPools() {
    return __awaiter(this, void 0, void 0, function* () {
        const calls = [];
        let factory;
        for (factory in subgraphs_1.IMPERMAX_SUBGRAPH_URL[this.network]) {
            // Multiple endpoints
            const subgraphs = subgraphs_1.IMPERMAX_SUBGRAPH_URL[this.network][factory];
            calls.push(this.endpointManager.fetch(subgraphs, this.network, (queryBuilder) => queryBuilder.lendingPoolsQuery(factory, [], this.network)));
        }
        const results = yield Promise.all(calls);
        const lendingPools = {};
        let i = 0;
        for (factory in subgraphs_1.IMPERMAX_SUBGRAPH_URL[this.network]) {
            lendingPools[factory] = results[i++].data.lendingPools;
        }
        return lendingPools;
    });
}
exports.fetchLendingPools = fetchLendingPools;
function fetchLendingPoolsPast(seconds) {
    return __awaiter(this, void 0, void 0, function* () {
        const timestamp = Math.floor((new Date).getTime() / 1000);
        const blockNumber = yield this.fetchBlockByTimestamp(timestamp - seconds);
        if (!blockNumber)
            return null;
        try {
            const calls = [];
            let factory;
            for (factory in subgraphs_1.IMPERMAX_SUBGRAPH_URL[this.network]) {
                const endpoints = subgraphs_1.IMPERMAX_SUBGRAPH_URL[this.network][factory];
                // Not all endpoints might support this
                const supportedEndpoints = endpoints.filter(endpoint => queries_1.QueryBuilderFactory.getQuery(endpoint).lendingPoolsPastQuery);
                // Skip if no endpoints support past queries for this factory
                if (supportedEndpoints.length === 0)
                    continue;
                // Query only from supported endpoints
                calls.push(this.endpointManager.fetch(supportedEndpoints, this.network, (queryBuilder) => queryBuilder.lendingPoolsPastQuery(blockNumber, this.whitelistedPairs[factory])));
            }
            const results = yield Promise.all(calls);
            const lendingPools = {};
            let i = 0;
            for (factory in subgraphs_1.IMPERMAX_SUBGRAPH_URL[this.network]) {
                lendingPools[factory] = results[i++].data.lendingPools;
            }
            return lendingPools;
        }
        catch (_a) {
            return null;
        }
    });
}
exports.fetchLendingPoolsPast = fetchLendingPoolsPast;
// Farming APR
function fetchImpermaxChefRewardRates() {
    return __awaiter(this, void 0, void 0, function* () {
        const subgraph = subgraphs_1.IMPERMAX_CHEF_SUBGRAPH_URL[this.network];
        const query = queries_1.QueryBuilderFactory.getQuery(subgraph);
        // `impermaxChefQuery` is optional, see `offchain/queries/interfaces/query-builder.ts`
        // Since it's not part of core, one endpoint should suffice
        if (!subgraph || !query.impermaxChefQuery)
            return null;
        const result = yield this.apolloFetcher(subgraph, query.impermaxChefQuery());
        const rewards = {};
        let rewardToken = result.data.impermaxChefs[0].rewardToken;
        let rewardPerSec = parseFloat(result.data.impermaxChefs[0].rewardPerSec);
        let totalAllocPoint = parseFloat(result.data.impermaxChefs[0].totalAllocPoint);
        const impermaxRewarders = result.data.impermaxRewarders;
        for (const pool of result.data.pools) {
            rewards[pool.id] = [];
            rewards[pool.id].push({
                rewardToken,
                rewardRate: parseFloat(pool.allocPoint) / totalAllocPoint * rewardPerSec
            });
        }
        for (const impermaxRewarder of impermaxRewarders) {
            rewardToken = impermaxRewarder.rewardToken;
            rewardPerSec = parseFloat(impermaxRewarder.rewardPerSec);
            totalAllocPoint = parseFloat(impermaxRewarder.totalAllocPoint);
            for (const pool of impermaxRewarder.pools) {
                if (!(pool.borrowable in rewards))
                    rewards[pool.borrowable] = [];
                rewards[pool.borrowable].push({
                    rewardToken,
                    rewardRate: parseFloat(pool.allocPoint) / totalAllocPoint * rewardPerSec
                });
            }
        }
        return rewards;
    });
}
exports.fetchImpermaxChefRewardRates = fetchImpermaxChefRewardRates;
// Uniswap APR
function fetchPastVolume(amm, lendingPools, seconds) {
    return __awaiter(this, void 0, void 0, function* () {
        const timestamp = Math.floor((new Date).getTime() / 1000);
        const blockNumber = yield this.fetchBlockByTimestamp(timestamp - seconds);
        if (!blockNumber)
            return {};
        let result;
        const pastVolume = {};
        try {
            const subgraph = amms_1.AMM_SUBGRAPH_URLS[this.network][amm];
            if (subgraph && subgraph.length > 0) {
                const query = queries_1.QueryBuilderFactory.getQuery(subgraph);
                // Since it's not part of core, one endpoint should suffice
                if (!query.pastVolumeQuery)
                    return {};
                result = yield this.apolloFetcher(subgraph, query.pastVolumeQuery(blockNumber, lendingPools.map(lendingPool => lendingPool.pair.uniswapV2PairAddress)));
                for (const pair of result.data.pairs) {
                    pastVolume[pair.id] = parseInt(pair.volumeUSD);
                }
            }
        }
        catch (e) {
            console.error(e);
        }
        return pastVolume;
    });
}
exports.fetchPastVolume = fetchPastVolume;
function fetchCurrentVolumeAndReserves(amm, lendingPools) {
    return __awaiter(this, void 0, void 0, function* () {
        let result;
        const currentVolume = {};
        const currentReserve = {};
        try {
            const subgraph = amms_1.AMM_SUBGRAPH_URLS[this.network][amm];
            const query = queries_1.QueryBuilderFactory.getQuery(subgraph);
            // Since it's not part of core, one endpoint should suffice
            if (!query.currentVolumeAndReservesQuery)
                return { currentReserve, currentVolume };
            result = yield this.apolloFetcher(subgraph, query.currentVolumeAndReservesQuery(lendingPools.map(lendingPool => lendingPool.pair.uniswapV2PairAddress)));
            for (const pair of result.data.pairs) {
                currentVolume[pair.id] = parseInt(pair.volumeUSD);
                currentReserve[pair.id] = parseInt(pair.reserveUSD);
            }
        }
        catch (e) {
            console.error(e);
        }
        return { currentReserve, currentVolume };
    });
}
exports.fetchCurrentVolumeAndReserves = fetchCurrentVolumeAndReserves;
function fetchUniswapAPR(lendingPoolsByAmm, seconds = 60 * 60 * 24 * 7) {
    return __awaiter(this, void 0, void 0, function* () {
        const uniswapAPR = {};
        const amms = Object.keys(lendingPoolsByAmm);
        const promises = [];
        for (const amm of amms) {
            if (!amms_1.AMM_SUBGRAPH_URLS[this.network][amm])
                continue;
            const lendingPools = lendingPoolsByAmm[amm];
            if (lendingPools === undefined)
                continue;
            promises.push(Promise.all([
                amm,
                this.fetchPastVolume(amm, lendingPools, seconds),
                this.fetchCurrentVolumeAndReserves(amm, lendingPools)
            ]));
        }
        const ammsData = yield Promise.all(promises);
        for (const data of ammsData) {
            const [amm, pastVolume, { currentVolume, currentReserve },] = data;
            const lendingPools = lendingPoolsByAmm[amm];
            if (lendingPools === undefined)
                continue;
            for (const lendingPool of lendingPools) {
                const uniswapV2PairAddress = lendingPool.pair.uniswapV2PairAddress;
                if (!currentReserve[uniswapV2PairAddress]) {
                    uniswapAPR[lendingPool.id] = 0;
                    continue;
                }
                const cumVolumePast = pastVolume[uniswapV2PairAddress] ? pastVolume[uniswapV2PairAddress] : 0;
                const cumVolumeNow = currentVolume[uniswapV2PairAddress];
                const reserveUSD = currentReserve[uniswapV2PairAddress];
                const volumeUSD = cumVolumeNow - cumVolumePast;
                const yearlyVolume = volumeUSD * SECONDS_IN_YEAR / seconds;
                const yearlyFee = yearlyVolume * amms_1.AMM_LP_FEE[this.network][amm];
                uniswapAPR[lendingPool.id] = yearlyFee / reserveUSD;
            }
        }
        return uniswapAPR;
    });
}
exports.fetchUniswapAPR = fetchUniswapAPR;
// OffchainLendingPool Data
function initializeLendingPoolsData() {
    return __awaiter(this, void 0, void 0, function* () {
        const lendingPoolsData = {};
        // Get raw data
        const [lendingPools, lendingPoolsPast24h, lendingPoolsPast7d, impermaxChefRewardRates,] = yield Promise.all([
            this.fetchLendingPools(),
            this.fetchLendingPoolsPast(24 * 3600),
            this.fetchLendingPoolsPast(7 * 24 * 3600),
            this.fetchImpermaxChefRewardRates(),
        ]);
        // Get Uniswap APR
        const lendingPoolsByAmm = {};
        for (const factory in lendingPools) {
            for (const lendingPool of lendingPools[factory]) {
                const amm = (0, amms_1.getAmmByFactory)(this.network, lendingPool.pair.uniswapV2Factory);
                if (!amm)
                    continue;
                if (!lendingPoolsByAmm[amm])
                    lendingPoolsByAmm[amm] = [];
                const lendingPoolsOfAmm = lendingPoolsByAmm[amm];
                lendingPoolsOfAmm.push(lendingPool);
            }
        }
        const uniswapAPR = yield this.fetchUniswapAPR(lendingPoolsByAmm);
        // Organize lending pools data
        for (const factory in lendingPools) {
            for (const lendingPool of lendingPools[factory]) {
                lendingPool.pair.uniswapAPR = uniswapAPR[lendingPool.id] || 0;
                if (impermaxChefRewardRates) {
                    lendingPool.borrowable0.rewards = impermaxChefRewardRates[lendingPool.borrowable0.id];
                    lendingPool.borrowable1.rewards = impermaxChefRewardRates[lendingPool.borrowable1.id];
                }
                // If one of the price of the 2 tokens is 0, fix the collateral price by doubling it
                if (parseFloat(lendingPool.borrowable0.underlying.derivedUSD) === 0 || parseFloat(lendingPool.borrowable1.underlying.derivedUSD) === 0) {
                    lendingPool.pair.derivedUSD = (parseFloat(lendingPool.pair.derivedUSD) * 2).toString();
                }
                if (!lendingPoolsData[factory])
                    lendingPoolsData[factory] = {};
                lendingPoolsData[factory][lendingPool.id] = lendingPool;
            }
            // Add past data
            if (lendingPoolsPast24h) {
                const lendingPoolsPast24hOfFactory = lendingPoolsPast24h[factory];
                if (lendingPoolsPast24hOfFactory) {
                    for (const lendingPool of lendingPoolsPast24hOfFactory) {
                        lendingPoolsData[factory][lendingPool.id].past24h = lendingPool;
                    }
                }
            }
            if (lendingPoolsPast7d) {
                const lendingPoolsPast7dhOfFactory = lendingPoolsPast7d[factory];
                if (lendingPoolsPast7dhOfFactory) {
                    for (const lendingPool of lendingPoolsPast7dhOfFactory) {
                        lendingPoolsData[factory][lendingPool.id].past7d = lendingPool;
                    }
                }
            }
        }
        // Initialize OffchainLendingPool objects
        this.lendingPools = {};
        for (const factory in lendingPools) {
            this.lendingPools[factory] = {};
            for (const lendingPool of lendingPools[factory]) {
                this.lendingPools[factory][lendingPool.id] =
                    new lendingPool_1.default(this, factory, lendingPool.id);
            }
        }
        // Quickfix for MIM and SPELL
        if (this.network === types_1.Networks.Arbitrum) {
            // const ETH_MIM = '0xa6e69dd0c36f3b59539e2c7afd274ef91b5c70f9';
            // const ETH_SPELL = '0x35b44b303eacb71114aa62fe8dae6f9c5de0f680';
            const ETH_gGOHM = '0x6d94f7e67c6ae0b0257c35754e059fdfb249d998';
            const ETH_MAGIC = '0x88a0b00bbe918ee00e3482f71962070dc052984b';
            const ETH_RDNT = '0xfb468ad210d427d65c9a765a480649d5754ca325';
            // const LIZ_LIZ_ETH = '0x699c5e23357ab1bf658bd0b38070d746e37671f3';
            // const LIZ_ETH_USDC = '0x1229aac120ae75301ab1c3a2a04ec14183493584';
            // const LIZ_ETH_BTC = '0xce009c44e1645bc6d19c90ba440c618a42ae581d';
            // const LIZ_LIZ_USDC = '0x463ec151258370a07431068bb3bdc98b5a6ba18f';
            const lendingPoolsDataV2V1_1 = lendingPoolsData[types_1.Factory.V2V1_1];
            if (lendingPoolsDataV2V1_1) {
                if (lendingPoolsDataV2V1_1[ETH_gGOHM]) {
                    //lendingPoolsData[Factory.V2V1_1][ETH_SPELL].pair.rewards[0].rewardRate = '8.44';
                    //lendingPoolsData[Factory.V2V1_1][ETH_MIM].pair.rewards[0].rewardRate = '30.64';
                    //lendingPoolsData[Factory.V2V1_1][ETH_gGOHM].pair.rewards[0].rewardRate = '0.000009129';
                    lendingPoolsDataV2V1_1[ETH_MAGIC].pair.rewards[0].rewardRate = '0.135';
                }
            }
            const lendingPoolsDataV2V2 = lendingPoolsData[types_1.Factory.V2V2];
            if (lendingPoolsDataV2V2) {
                if (lendingPoolsDataV2V2[ETH_RDNT]) {
                    lendingPoolsDataV2V2[ETH_RDNT].pair.rewards[0].rewardRate = (parseFloat(lendingPoolsDataV2V2[ETH_RDNT].pair.rewards[0].rewardRate) / 2).toString();
                }
            }
            /*if (lendingPoolsData[Factory.SOLV2][LIZ_LIZ_ETH]) {
              const LIZ = lendingPoolsData[Factory.SOLV2][LIZ_LIZ_ETH].borrowable0.underlying;
              lendingPoolsData[Factory.SOLV2][LIZ_LIZ_ETH].pair.rewards = [{
                id: '',
                rewardsToken: LIZ,
                rewardRate: '3.724',
                periodFinish: '0',
              }];
              lendingPoolsData[Factory.SOLV2][LIZ_LIZ_ETH].pair.stakedTotalSupply = '40131.19426';
              lendingPoolsData[Factory.SOLV2][LIZ_ETH_USDC].pair.rewards = [{
                id: '',
                rewardsToken: LIZ,
                rewardRate: '1.284',
                periodFinish: '0',
              }];
              lendingPoolsData[Factory.SOLV2][LIZ_ETH_USDC].pair.stakedTotalSupply = '0.182614';
              lendingPoolsData[Factory.SOLV2][LIZ_ETH_BTC].pair.rewards = [{
                id: '',
                rewardsToken: LIZ,
                rewardRate: '0.159',
                periodFinish: '0',
              }];
              lendingPoolsData[Factory.SOLV2][LIZ_ETH_BTC].pair.stakedTotalSupply = '0.002468';
              lendingPoolsData[Factory.SOLV2][LIZ_LIZ_USDC].pair.rewards = [{
                id: '',
                rewardsToken: LIZ,
                rewardRate: '1.566',
                periodFinish: '0',
              }];
              lendingPoolsData[Factory.SOLV2][LIZ_LIZ_USDC].pair.stakedTotalSupply = '0.568227';
            }*/
        }
        if (this.network === types_1.Networks.Polygon) {
            const lendingPoolsDataV2V2 = lendingPoolsData[types_1.Factory.V2V2];
            if (lendingPoolsDataV2V2) {
                const GNS_DAI = '0xf9221c5edc736d26ffc4ddccddfa15a4b958862e';
                if (lendingPoolsDataV2V2[GNS_DAI]) {
                    const GNS = lendingPoolsDataV2V2[GNS_DAI].borrowable1.underlying;
                    lendingPoolsDataV2V2[GNS_DAI].pair.rewards[0] = {
                        id: '',
                        rewardsToken: GNS,
                        rewardRate: '0.00608',
                        periodFinish: '0',
                    };
                    lendingPoolsDataV2V2[GNS_DAI].pair.stakedTotalSupply = '1640000';
                }
            }
        }
        if (this.network === types_1.Networks.Avalanche) {
            const lendingPoolsDataV2V1_2 = lendingPoolsData[types_1.Factory.V2V1_2];
            if (lendingPoolsDataV2V1_2) {
                const QI_AVAX = '0x3e2a4dcd46e0e339aec603080d90bd939a163062';
                if (lendingPoolsDataV2V1_2[QI_AVAX]) {
                    const QI = lendingPoolsDataV2V1_2[QI_AVAX].borrowable0.underlying;
                    lendingPoolsDataV2V1_2[QI_AVAX].pair.rewards[0] = {
                        id: '',
                        rewardsToken: QI,
                        rewardRate: '4.54',
                        periodFinish: '0',
                    };
                    // TODO -> this is wrong
                    lendingPoolsDataV2V1_2[QI_AVAX].pair.stakedTotalSupply = '0.000000992210460243'; //https://snowtrace.io/token/0xe530dc2095ef5653205cf5ea79f8979a7028065c?a=0x784da19e61cf348a8c54547531795ecfee2affd1
                }
            }
            /*REWARD STOPPED const sAVAX_AVAX = '0x5b588f4481035b0f765393fc9f4752615a6d0498';
            if (lendingPoolsData[Factory.V2V1_2][sAVAX_AVAX]) {
              const QI = lendingPoolsData[Factory.V2V1_2][QI_AVAX].borrowable0.underlying;
              lendingPoolsData[Factory.V2V1_2][sAVAX_AVAX].pair.rewards[1] = {
                id: '',
                rewardsToken: QI,
                rewardRate: '1.74',
                periodFinish: '0',
              };
            }
            const UST_AVAX = '0xc6e68d77d0f4fa925a1cf2611dab6b10900eaf2b';
            if (lendingPoolsData[Factory.V2V1_2][UST_AVAX]) {
              const AVAX = lendingPoolsData[Factory.V2V1_2][UST_AVAX].borrowable1.underlying;
              lendingPoolsData[Factory.V2V1_2][UST_AVAX].pair.rewards[0].rewardRate = '0.000099';
              lendingPoolsData[Factory.V2V1_2][UST_AVAX].pair.rewards[2] = {
                id: '',
                rewardsToken: AVAX,
                rewardRate: '0.00047',
                periodFinish: '0',
              };
            }
            const UST_USDC = '0x69c1c44e8742b66d892294a7eeb9aac51891b0eb';
            if (lendingPoolsData[Factory.V2V1_2][UST_USDC]) {
              const AVAX = lendingPoolsData[Factory.V2V1_2][UST_AVAX].borrowable1.underlying;
              lendingPoolsData[Factory.V2V1_2][UST_USDC].pair.rewards[0].rewardRate = '0.000099';
              lendingPoolsData[Factory.V2V1_2][UST_USDC].pair.rewards[2] = {
                id: '',
                rewardsToken: AVAX,
                rewardRate: '0.00047',
                periodFinish: '0',
              };
            }*/
        }
        return lendingPoolsData;
    });
}
exports.initializeLendingPoolsData = initializeLendingPoolsData;
function getLendingPoolsData() {
    return __awaiter(this, void 0, void 0, function* () {
        if (!this.lendingPoolsData)
            this.lendingPoolsData = this.initializeLendingPoolsData();
        return this.lendingPoolsData;
    });
}
exports.getLendingPoolsData = getLendingPoolsData;
function getLendingPoolData(factory, uniswapV2PairAddress) {
    return __awaiter(this, void 0, void 0, function* () {
        const lendingPoolsData = (yield this.getLendingPoolsData())[factory];
        return lendingPoolsData[uniswapV2PairAddress.toLowerCase()];
    });
}
exports.getLendingPoolData = getLendingPoolData;
// TVL Data
function initializeTvlData() {
    return __awaiter(this, void 0, void 0, function* () {
        const networks = [
            types_1.Networks.Mainnet,
            types_1.Networks.Arbitrum,
            types_1.Networks.Polygon,
            types_1.Networks.Avalanche,
            types_1.Networks.Fantom,
            // Networks.Canto,
            // Networks.Mantle,
            // Networks.Moonriver,
            types_1.Networks.ZksyncEra,
            types_1.Networks.Base,
            types_1.Networks.Scroll,
            types_1.Networks.Real,
            types_1.Networks.Blast,
            types_1.Networks.Sonic,
            types_1.Networks.Linea,
        ]; // exclude ropsten
        const calls = [];
        for (const network of networks) {
            for (const factory in subgraphs_1.IMPERMAX_SUBGRAPH_URL[network]) {
                // Multiple endpoints
                const subgraphs = subgraphs_1.IMPERMAX_SUBGRAPH_URL[network][factory];
                calls.push(this.endpointManager.fetch(subgraphs, network, (queryBuilder) => queryBuilder.tvlQuery()));
            }
        }
        let results;
        try {
            results = yield Promise.all(calls);
        }
        catch (e) {
            console.log("can't initialize TVL data");
            return {
                crossChainTVLUSD: 0,
                crossChainSupplyUSD: 0,
                crossChainBorrowUSD: 0,
                totalBalanceUSD: 0,
                totalSupplyUSD: 0,
                totalBorrowsUSD: 0,
            };
        }
        let crossChainTVLUSD = 0;
        let crossChainSupplyUSD = 0;
        let crossChainBorrowUSD = 0;
        let thisChainTVLUSD = 0;
        let thisChainSupplyUSD = 0;
        let thisChainBorrowUSD = 0;
        let i = 0;
        for (const network of networks) {
            for (const _ in subgraphs_1.IMPERMAX_SUBGRAPH_URL[network]) {
                // Need to pluralize `impermaxFactory`
                const data = queries_1.QueryBuilderFactory.getImpermaxFactory(results[i]);
                if (data) {
                    crossChainTVLUSD += parseFloat(data.totalBalanceUSD);
                    crossChainSupplyUSD += parseFloat(data.totalSupplyUSD);
                    crossChainBorrowUSD += parseFloat(data.totalBorrowsUSD);
                    if (network === this.network) {
                        thisChainTVLUSD += parseFloat(data.totalBalanceUSD);
                        thisChainSupplyUSD += parseFloat(data.totalSupplyUSD);
                        thisChainBorrowUSD += parseFloat(data.totalBorrowsUSD);
                    }
                }
                i++;
            }
        }
        if (!networks.includes(this.network)) {
            const calls = [];
            for (const factory in subgraphs_1.IMPERMAX_SUBGRAPH_URL[this.network]) {
                // Multiple endpoints
                const subgraphs = subgraphs_1.IMPERMAX_SUBGRAPH_URL[this.network][factory];
                calls.push(this.endpointManager.fetch(subgraphs, this.network, (queryBuilder) => queryBuilder.tvlQuery()));
            }
            const results = yield Promise.all(calls);
            i = 0;
            for (const _ in subgraphs_1.IMPERMAX_SUBGRAPH_URL[this.network]) {
                // Need to pluralize `impermaxFactory`
                const data = queries_1.QueryBuilderFactory.getImpermaxFactory(results[i]);
                if (data) {
                    thisChainTVLUSD += parseFloat(data.totalBalanceUSD);
                    thisChainSupplyUSD += parseFloat(data.totalSupplyUSD);
                    thisChainBorrowUSD += parseFloat(data.totalBorrowsUSD);
                }
                i++;
            }
        }
        return {
            crossChainTVLUSD,
            crossChainSupplyUSD,
            crossChainBorrowUSD,
            totalBalanceUSD: thisChainTVLUSD,
            totalSupplyUSD: thisChainSupplyUSD,
            totalBorrowsUSD: thisChainBorrowUSD,
        };
    });
}
exports.initializeTvlData = initializeTvlData;
function getTvlData() {
    return __awaiter(this, void 0, void 0, function* () {
        if (!this.tvlData)
            this.tvlData = this.initializeTvlData();
        return this.tvlData;
    });
}
exports.getTvlData = getTvlData;
// User Data
function fetchUserData(account) {
    return __awaiter(this, void 0, void 0, function* () {
        const positions = {};
        for (const factory in subgraphs_1.IMPERMAX_SUBGRAPH_URL[this.network]) {
            const subgraphs = subgraphs_1.IMPERMAX_SUBGRAPH_URL[this.network][factory];
            // We pass network + factory to get the actual factory address in case we use multiple factories in 1 api
            const result = yield this.endpointManager.fetch(subgraphs, this.network, (queryBuilder) => queryBuilder.userQuery(account, this.network, factory));
            const user = result.data.user;
            if (!user)
                continue;
            positions[factory] = {
                collateralPositions: user.collateralPositions,
                supplyPositions: user.supplyPositions,
                borrowPositions: user.borrowPositions,
            };
        }
        return positions;
        // TODO parallelize calls
    });
}
exports.fetchUserData = fetchUserData;
function initializeUserData(account) {
    return __awaiter(this, void 0, void 0, function* () {
        const result = {};
        const userData = yield this.fetchUserData(account);
        if (!userData)
            return null;
        let factory;
        for (factory in userData) {
            result[factory] = {
                collateralPositions: {},
                supplyPositions: {},
                borrowPositions: {},
            };
            const rawUserData = userData[factory];
            for (const collateralPosition of rawUserData.collateralPositions) {
                const resultOfFactory = result[factory];
                resultOfFactory.collateralPositions[collateralPosition.collateral.lendingPool.id] = collateralPosition;
            }
            for (const supplyPositions of rawUserData.supplyPositions) {
                const uniswapV2PairAddress = supplyPositions.borrowable.lendingPool.id;
                const underlyingAddress = supplyPositions.borrowable.underlying.id;
                const borrowableA = (yield this.getLendingPool(factory, uniswapV2PairAddress)).getPoolToken(types_1.PoolTokenType.BorrowableA);
                const addressA = yield borrowableA.getUnderlyingAddress();
                const poolTokenType = underlyingAddress === addressA ? types_1.PoolTokenType.BorrowableA : types_1.PoolTokenType.BorrowableB;
                const resultOfFactory = result[factory];
                if (!(uniswapV2PairAddress in resultOfFactory.supplyPositions))
                    resultOfFactory.supplyPositions[uniswapV2PairAddress] = {};
                resultOfFactory.supplyPositions[uniswapV2PairAddress][poolTokenType] = supplyPositions;
            }
            for (const borrowPositions of rawUserData.borrowPositions) {
                const uniswapV2PairAddress = borrowPositions.borrowable.lendingPool.id;
                const underlyingAddress = borrowPositions.borrowable.underlying.id;
                const borrowableA = (yield this.getLendingPool(factory, uniswapV2PairAddress)).getPoolToken(types_1.PoolTokenType.BorrowableA);
                const addressA = yield borrowableA.getUnderlyingAddress();
                const poolTokenType = underlyingAddress === addressA ? types_1.PoolTokenType.BorrowableA : types_1.PoolTokenType.BorrowableB;
                const resultOfFactory = result[factory];
                if (!(uniswapV2PairAddress in resultOfFactory.borrowPositions))
                    resultOfFactory.borrowPositions[uniswapV2PairAddress] = {};
                resultOfFactory.borrowPositions[uniswapV2PairAddress][poolTokenType] = borrowPositions;
            }
        }
        return result;
    });
}
exports.initializeUserData = initializeUserData;
function getUserData(account) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!(account in this.usersData))
            this.usersData[account] = this.initializeUserData(account);
        return this.usersData[account];
    });
}
exports.getUserData = getUserData;
// IMX Staking
function initializeXimxData() {
    return __awaiter(this, void 0, void 0, function* () {
        const subgraph = subgraphs_1.XIMX_SUBGRAPH_URL;
        const query = queries_1.QueryBuilderFactory.getQuery(subgraph);
        const result = yield apolloFetcher(subgraph, query.ximxQuery());
        return result.data.ximxes[0];
    });
}
exports.initializeXimxData = initializeXimxData;
function getXimxData() {
    return __awaiter(this, void 0, void 0, function* () {
        if (!this.ximxData)
            this.ximxData = this.initializeXimxData();
        return this.ximxData;
    });
}
exports.getXimxData = getXimxData;
/**
 * Lending Vault
 **/
function fetchLendingVaults() {
    return __awaiter(this, void 0, void 0, function* () {
        const subgraph = subgraphs_1.LENDING_VAULT_SUBGRAPH_URL[this.network];
        const query = queries_1.QueryBuilderFactory.getQuery(subgraph);
        const result = yield this.apolloFetcher(subgraph, query.lendingVaultsQuery([]));
        return result.data.lendingVaults;
    });
}
exports.fetchLendingVaults = fetchLendingVaults;
function initializeLendingVaultsData() {
    return __awaiter(this, void 0, void 0, function* () {
        const lendingVaultsData = {};
        const lendingVaults = yield this.fetchLendingVaults();
        // Organize lending vaults data
        for (const lendingVault of lendingVaults) {
            lendingVaultsData[lendingVault.id] = lendingVault;
        }
        // Initialize OffchainLendingVault objects
        this.lendingVaults = {};
        for (const lendingVault of lendingVaults) {
            this.lendingVaults[lendingVault.id] =
                new offchainLendingVault_1.default(this, lendingVault.id);
        }
        return lendingVaultsData;
    });
}
exports.initializeLendingVaultsData = initializeLendingVaultsData;
function getLendingVaultsData() {
    return __awaiter(this, void 0, void 0, function* () {
        if (!this.lendingVaultsData)
            this.lendingVaultsData = this.initializeLendingVaultsData();
        return this.lendingVaultsData;
    });
}
exports.getLendingVaultsData = getLendingVaultsData;
function getLendingVaultData(lendingVaultAddress) {
    return __awaiter(this, void 0, void 0, function* () {
        const lendingVaultsData = yield this.getLendingVaultsData();
        return lendingVaultsData[lendingVaultAddress.toLowerCase()];
    });
}
exports.getLendingVaultData = getLendingVaultData;
/**
 * Whitelist
 */
function fetchWhitelist() {
    return __awaiter(this, void 0, void 0, function* () {
        const subgraph = subgraphs_1.WHITELIST_SUBGRAPH_URL[this.network];
        if (!subgraph)
            return [];
        const query = queries_1.QueryBuilderFactory.getQuery(subgraph);
        if (!query.whitelistQuery)
            return [];
        const result = yield this.apolloFetcher(subgraph, query.whitelistQuery());
        if (!result || !result.data.whitelistStates)
            return [];
        return result.data.whitelistStates;
    });
}
exports.fetchWhitelist = fetchWhitelist;
function initializeWhitelistData() {
    return __awaiter(this, void 0, void 0, function* () {
        const whitelistData = {};
        const whitelistPairsData = yield this.fetchWhitelist();
        // Organize lending vaults data
        for (const whitelistPairData of whitelistPairsData) {
            const factory = (0, impermax_factories_1.getFactoryByAddress)(this.network, whitelistPairData.factory);
            if (!factory)
                continue;
            if (!whitelistData[factory])
                whitelistData[factory] = {};
            const whitelistDataOfFactory = whitelistData[factory];
            whitelistDataOfFactory[whitelistPairData.pair] = whitelistPairData.state;
        }
        return whitelistData;
    });
}
exports.initializeWhitelistData = initializeWhitelistData;
function getWhitelistData() {
    return __awaiter(this, void 0, void 0, function* () {
        if (!this.whitelistData)
            this.whitelistData = this.initializeWhitelistData();
        return this.whitelistData;
    });
}
exports.getWhitelistData = getWhitelistData;
function getWhitelistState(factory, pair) {
    return __awaiter(this, void 0, void 0, function* () {
        const whitelistData = yield this.getWhitelistData();
        const whitelistDataOfFactory = whitelistData[factory];
        if (!whitelistDataOfFactory)
            return types_1.WhitelistState.Unlisted;
        if (!whitelistDataOfFactory[pair.toLowerCase()])
            return types_1.WhitelistState.Unlisted;
        return whitelistDataOfFactory[pair.toLowerCase()];
    });
}
exports.getWhitelistState = getWhitelistState;
/**
 * User Data
 */
function fetchLendingVaultsUserData(account) {
    return __awaiter(this, void 0, void 0, function* () {
        const subgraph = subgraphs_1.LENDING_VAULT_SUBGRAPH_URL[this.network];
        const query = queries_1.QueryBuilderFactory.getQuery(subgraph);
        const result = yield this.apolloFetcher(subgraph, query.lendingVaultsUserQuery(account));
        const user = result.data.user;
        if (!user)
            return null;
        return result.data.user.positions;
    });
}
exports.fetchLendingVaultsUserData = fetchLendingVaultsUserData;
function initializeLendingVaultsUserData(account) {
    return __awaiter(this, void 0, void 0, function* () {
        const positions = yield this.fetchLendingVaultsUserData(account);
        if (!positions)
            return null;
        const result = {};
        for (const position of positions) {
            result[position.lendingVault.id] = position;
        }
        return result;
    });
}
exports.initializeLendingVaultsUserData = initializeLendingVaultsUserData;
function getLendingVaultsUserData(account) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!(account in this.lendingVaultsUsersData))
            this.lendingVaultsUsersData[account] = this.initializeLendingVaultsUserData(account);
        return yield this.lendingVaultsUsersData[account];
    });
}
exports.getLendingVaultsUserData = getLendingVaultsUserData;
